
<template>
  <div class="load scroll-y">
    <div class="card white reverse item">
      <div class="full-height row">
        <!-- QR -->
        <div class="row center-items mt-3 mb-2">
          <!-- confirmate code -->
          <qrcode-vue :value="confirmQR" size="100" level="M"></qrcode-vue>
        </div>

        <div class="dashed mb-2 dark"></div>
        <div
          class="medium capital subtitle dark mb-1 pb-1 center-text"
        >{{$store.getters.app.profile.name}}</div>

        <!-- PAYLOAD -->
        <div class="mr-3 ml-3 mb-2 body-2 secondary-text medium">
          <div class="row capital mb-1">
            <div>Servidor</div>
            <div class="dashed-service ml-1 mr-1 spacer"></div>
            <div>{{$store.getters.dataTicket.serverName}}</div>
          </div>
          <div class="row mb-1">
            <div>Hora de la cita</div>
            <div class="dashed-service ml-1 mr-1 spacer"></div>
            <div>{{$store.getters.dataTicket.time}}</div>
          </div>
          <div class="row mb-1">
            <div>Fecha de reserva</div>
            <div class="dashed-service ml-1 mr-1 spacer"></div>
            <div
              class="capital"
            >{{$store.getters.dataTicket.dayMonth}} {{$store.getters.dataTicket.month}}</div>
          </div>
          <div class="row mb-1">
            <div>Servicio</div>
            <div class="dashed-service ml-1 mr-1 spacer"></div>
            <div>{{$store.getters.dataTicket.serviceName}}</div>
          </div>
          <div class="row mb-1">
            <div>Lugar</div>
            <div class="dashed-service ml-1 mr-1 spacer"></div>
            <div>{{$store.getters.dataTicket.serverCampus}}</div>
          </div>

          <div class="row capital mb-1">
            <div class="row">
              <div class="center-items col pr-1">
                <div class="spacer"></div>
                <div class>Cliente</div>
              </div>
              <div class="dashed-service ml-1 row row spacer"></div>
            </div>

            <!-- INPUT -->

            <input
              v-if="$store.getters.dataTicket.state != 'confirmado'"
              v-model="changeClient"
              class="bizel capital height-20 border-line-1 right-text reverse body pl-2 pr-2"
              :placeholder="$store.getters.dataTicket.clientNames"
              type="name"
            />

            <div v-else class="row right-text">
              <div class="dashed-service row mr-1 row spacer"></div>
              <div>{{$store.getters.dataTicket.clientNames}}</div>
            </div>
          </div>

          <div class="row capital mb-1">
            <div class="row">
              <div class="center-items col pr-1">
                <div class="spacer"></div>
                <div class>Total</div>
              </div>
              <div class="dashed-service ml-1 row row spacer"></div>
            </div>

            <!-- INPUT -->

            <input
              v-if="$store.getters.dataTicket.state != 'confirmado'"
              @blur="focusOut"
              @focus="focusIn"
              v-model="formattedCurrencyValue"
              class="bizel height-20 border-line-1 right-text reverse body pl-2 pr-2"
              :placeholder="'$ ' + $store.getters.dataTicket.servicePrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' ' + $store.getters.app.country.currency"
              type="tel"
            />

            <div v-else class="row right-text">
              <div class="dashed-service row mr-1 row spacer"></div>
              <div>{{'$ ' + $store.getters.dataTicket.servicePrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' ' + $store.getters.app.country.currency}}</div>
            </div>
          </div>

          <div
            class="row pt-1 regular body"
          >Puedes cancelar en cualquier momento, recuerda estar al menos 10 minutos antes para tu cita</div>
        </div>

        <!-- NIVEL INVITADO -->
        <div v-if="$store.getters.profile.license == 'invitado'" class="col pr-3 pl-3 theme mb-2">
          <div
            class="mb-1 grey bizel height-50 center-items center-text row medium uppercased normal"
          >requiere autenticación</div>
          <div
            @click.stop="$store.dispatch('logout')"
            class="reverse height-50 center-items row medium uppercased normal isButton2"
          >INSCRIBIRME</div>
        </div>

        <!-- NIVEL 0 -->
        <div
          v-else-if="$store.getters.dataTicket.state == 'disponible'"
          class="col pr-3 pl-3 theme mb-2"
        >
          <div
            @click.stop="reserve"
            class="mb-1 primary bizel height-50 center-items row medium uppercased normal isButton2"
          >Confirmar reserva</div>
          <div
            @click.stop="$store.commit('closed')"
            class="reverse height-50 center-items row medium uppercased normal isButton2"
          >cerrar</div>
        </div>

        <!-- ADMIN -->

        <div v-else-if="$store.getters.profile.adminLevel > 1  " class="col pr-3 pl-3 theme mb-2">
          <div class="row">
            <div
              v-if="$store.getters.profile.adminLevel > 3 && $store.getters.dataTicket.state != 'confirmado'"
              @click.stop="confirmReserve"
              class="mb-1 mr-1 green bizel height-50 center-items row medium uppercased center-text text isButton2"
            >
              CONFIRMAR
              <br />
              {{formattedCurrencyValue}}
            </div>
            <div
              v-if="$store.getters.profile.clientID == $store.getters.dataTicket.clientID && $store.getters.profile.adminLevel < 3"
              @click.stop="cancelReserve"
              class="red bizel height-50 center-items mr-1 row medium uppercased center-text text isButton2"
            >CANCELAR reserva</div>
            <div
              v-else
              :class="$store.getters.profile.adminLevel > 3 ? 'blue': 'reverse' "
              @click.stop="$store.dispatch('goLink', `https://api.whatsapp.com/send?phone=${$store.getters.app.country.prefix}${$store.getters.dataTicket.clientPhone}&text=${$store.getters.app.profile.name}`)"
              class="height-50 bizel center-items row uppercased medium center-text text isButton2"
            >mensaje WhatsApp</div>
          </div>
          <div class="row">
            <div
              v-if="$store.getters.profile.adminLevel > 3 && $store.getters.dataTicket.state != 'confirmado'"
              @click.stop="cancelReserve"
              class="red bizel height-50 center-items mr-1 row medium uppercased center-text text isButton2"
            >CANCELAR reserva</div>
            <div
              @click.stop="$store.commit('closed')"
              class="reverse height-50 center-items row medium uppercased normal isButton2"
            >cerrar</div>
          </div>
        </div>

        <!-- NORMAL -->
        <div
          v-else-if="$store.getters.dataTicket.state == 'reservado'"
          class="col pr-3 pl-3 theme mb-2"
        >
          <div
            @click.stop="cancelReserve"
            class="mb-1 red bizel height-50 center-items row medium uppercased normal isButton2"
          >CANCELAR reserva</div>
          <div
            @click.stop="$store.commit('closed')"
            class="reverse height-50 center-items row medium uppercased normal isButton2"
          >cerrar</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import QrcodeVue from "qrcode.vue";
export default {
  data: () => ({
    currencyValue: 0,
    formattedCurrencyValue: "",
    changeClient: ""
  }),
  components: {
    QrcodeVue
  },
  methods: {
    reserve() {
      if (this.changeClient != "") {
        this.$store.commit("changeClient", this.changeClient);
      }

      if (this.currencyValue != 0 && this.formattedCurrencyValue != "") {
        this.$store.commit("changePrice", this.currencyValue);
      }
      this.$store.dispatch("reserve");
    },
    cancelReserve() {
      this.$store.dispatch("cancelReserve");
    },
    confirmReserve() {
      if (this.changeClient != "") {
        this.$store.commit("changeClient", this.changeClient);
      }

      if (this.currencyValue != 0 && this.formattedCurrencyValue != "") {
        this.$store.commit("changePrice", this.currencyValue);
      }
      this.$store.dispatch("confirmReserve");
    },
    focusOut() {
      // Recalculate the currencyValue after ignoring "$" and "," in user input
      this.currencyValue = parseFloat(
        this.formattedCurrencyValue.replace(/[^\d\.]/g, "")
      );
      // Ensure that it is not NaN. If so, initialize it to zero.
      // This happens if user provides a blank input or non-numeric input like "abc"
      if (isNaN(this.currencyValue)) {
        this.currencyValue = parseInt(
          this.$store.getters.dataTicket.servicePrice
        );
      }
      // Format display value based on calculated currencyValue
      this.formattedCurrencyValue =
        "$ " +
        this.currencyValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") +
        " " +
        this.$store.getters.app.country.currency;
    },
    focusIn() {
      if (this.currencyValue == 0) {
        this.formattedCurrencyValue = "";
      } else {
        this.formattedCurrencyValue = this.currencyValue.toString();
      }
    }
  },
  computed: {
    confirmQR() {
      return this.$store.getters.app.profile.nequi;
    }
  }
};
</script>
<style scoped>
input {
  margin-top: 0;
  margin-bottom: 0;
}
.load {
  position: fixed;
  z-index: 500;
  width: 100vw;
  display: flex;
  justify-content: center;
  min-height: 100vh;
}

.card {
  border-radius: 30px;
  position: absolute;
  width: 290px;
  overflow: hidden;
  margin-bottom: 20px;
  top: 80px;
}
.dashed {
  border-top: 3px dashed;
  opacity: 0.9;
}
.dashed-service {
  margin-right: 2.5px;
  border-bottom: 2.5px dotted;
  opacity: 0.3;
}
</style>